module.exports = "<as-notifier></as-notifier>\n<as-image-overlay></as-image-overlay>\n<div class=\"cloudUI fullHeight\">\n    <div class=\"fullHeight\">\n        <div class=\"containerFlex\">\n            <div class=\"flex flex-center\">\n                <div class=\"flex-column\">\n                    <div class=\"cloudContainer\">\n                        <div ui-view class=\"fullHeight\"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<as-loading-mask></as-loading-mask>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/cloud/cloud.component.html
// module id = 526
// module chunks = 0